export type TAppointmenTimeSlot = {
  hour: number;
  minute: number;
  format: '12h' | '24h';
  period?: 'AM' | 'PM';
}

export type TAppointmentDateTimeSlot = {
  start: string; // ISO string
  end: string; // ISO string
};

export enum EAppointmentType {
  GOOGLE_MEET = 'google_meet',
  PHYSICAL = 'physical',
}

export type TAppointmentModalState = {
  projectId?: number;
  dateTimeSlot?: TAppointmentDateTimeSlot;
  name: string;
  email: string;
  phone: string;
  appointmentType: EAppointmentType;
  duration: number;
  notes: string;
  selectedDate?: Date;
};

export type TAppointmentProjectMinimal = {
  id: number;
  title: string;
};

export type AppointmentCreationState = 'idle' | 'creating' | 'success';
